import type { FetchMatcher, JsonApiDoc } from 'tio-data/demo/types';
import { demoLoanEnumRows } from 'tio-employee/demo/loan-profile';

const ENUMS_QUERY_RE = /\/enums\?([^#]*)$/;

const flavorOf = (dot: string) => dot.split('.')[0] ?? '';

// A flavor-only filter, as the account table sends; any other query falls to the block.
function servedFlavor(url: string) {
  const query = ENUMS_QUERY_RE.exec(url)?.[1];
  if (query === undefined) {
    return undefined;
  }
  const params = new URLSearchParams(query);
  const flavor = params.get('filter[flavor]');
  if (!flavor || [...params.keys()].length !== 1) {
    return undefined;
  }
  return demoLoanEnumRows().some((row) => flavorOf(row.dot) === flavor) ? flavor : undefined;
}

function enumList(flavor: string | undefined): JsonApiDoc {
  return {
    data: demoLoanEnumRows()
      .filter((row) => flavorOf(row.dot) === flavor)
      .map(({ dot, description }) => ({
        type: 'enum',
        id: `demo-enum-${dot}`,
        attributes: { flavor: flavorOf(dot), name: dot.split('.')[1] ?? '', dot, description },
      })),
  };
}

/** Fetch-seam matcher for the enum lists that turn the demo loan's plan and status dots into text. */
export function buildLoanEnumFetchMatchers(): FetchMatcher[] {
  return [
    {
      urlMatches: (url) => servedFlavor(url) !== undefined,
      method: 'GET',
      json: (url: string) => enumList(servedFlavor(url)),
    },
  ];
}
